const routes = [
  {
    path: '/',
    name: 'JobList',
    meta: { requiresAuth: true, title: 'Jobs List', isInternal: true },
    component: () => import('@/views/JobList.vue')
  },
  {
    path: '/canceled',
    name: 'CanceledJobs',
    meta: { requiresAuth: true, title: 'Canceled Jobs', isInternal: true },
    component: () => import('@/views/CanceledJobList.vue')
  },
  {
    path: '/code/:jobShortCode',
    name: 'JobShortCodeRedirect',
    meta: { requiresAuth: true, isInternal: true },
    component: () => import('@/components/JobShortCodeRedirect.vue')
  },
  {
    path: '/:jobId([a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12})',
    name: 'JobDetail',
    meta: { requiresAuth: true, isInternal: true },
    component: () => import('@/views/JobDetail.vue')
  },
  {
    path: '/contractors',
    name: 'ContractorsList',
    meta: { requiresAuth: true, title: 'Contractors List', isInternal: true },
    component: () => import('@/views/ContractorsList.vue')
  },
  {
    path: '/announcements',
    name: 'AnnouncementsList',
    meta: { requiresAuth: true, title: 'Announcements List', isInternal: true },
    component: () => import('@/views/AnnouncementsList.vue')
  },
  {
    path: '/announcements/:announcementId',
    name: 'AnnouncementDetail',
    meta: {
      requiresAuth: true,
      title: 'Announcement Details',
      isInternal: true
    },
    component: () => import('@/views/AnnouncementDetail.vue')
  },
  {
    path: '/programs',
    name: 'ProgramsList',
    meta: { requiresAuth: true, title: 'Programs List', isInternal: true },
    component: () => import('@/views/ProgramsList.vue')
  },
  {
    path: '/programs/:programId',
    name: 'ProgramDetail',
    meta: { requiresAuth: true, title: 'Program Details', isInternal: true },
    component: () => import('@/views/ProgramDetail.vue')
  },
  {
    path: '/program-explorer',
    name: 'ProgramExplorer',
    meta: {
      requiresAuth: true,
      title: 'Program Explorer',
      isInternal: true
    },
    component: () => import('@/views/ProgramExplorer.vue')
  },
  {
    path: '/providers',
    name: 'EnergyProvidersList',
    meta: {
      requiresAuth: true,
      title: 'Energy Providers List',
      isInternal: true
    },
    component: () => import('@/views/EnergyProvidersList.vue')
  },
  {
    path: '/providers/:providerId',
    name: 'EnergyProviderDetail',
    meta: {
      requiresAuth: true,
      title: 'Energy Provider Details',
      isInternal: true
    },
    component: () => import('@/views/EnergyProviderDetail.vue')
  },
  {
    path: '/contractors/:contractorId',
    name: 'ContractorDetail',
    meta: { requiresAuth: true, title: 'Contractor Details', isInternal: true },
    component: () => import('@/views/ContractorDetail.vue')
  },
  {
    path: '/contractors/create',
    name: 'ContractorCreate',
    meta: { requiresAuth: true, title: 'New Contractor', isInternal: true },
    component: () => import('@/views/ContractorCreate.vue')
  },
  {
    path: '/terms_and_conditions',
    name: 'TermsAndConditionsList',
    meta: {
      requiresAuth: true,
      title: 'Terms and Conditions',
      isInternal: true
    },
    component: () => import('@/views/TermsAndConditionsList.vue')
  },
  {
    path: '/terms_and_conditions/:termsAndConditionsId',
    name: 'TermsAndConditionsDetail',
    meta: {
      requiresAuth: true,
      title: 'Terms and Conditions',
      isInternal: true
    },
    component: () => import('@/views/TermsAndConditionsDetail.vue')
  },
  {
    path: '/equipment',
    name: 'Equipment',
    meta: { requiresAuth: true, title: 'Equipment', isInternal: true },
    component: () => import('@/views/Equipment.vue')
  }
];

export default routes;
